import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const accordionSummary = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  > div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;

export const accordionSummaryTitle = (completed: boolean, blocked?: boolean) => css`
  color: ${blocked ? colors.gray.DEFAULT : colors.gray.dark};
  text-decoration: ${completed ? 'line-through' : 'none'};
`;

export const accordionSummaryIcon = (blocked?: boolean) => css`
  width: 16px;
  height: 16px;
  color: ${blocked ? colors.gray[8] : colors.gray.dark};
`;

export const accordionContainer = css`
  border-radius: 5px;
  border: 1px solid ${colors.gray.light};
  overflow: hidden;
`;

export const accordionSummaryWrapper = css`
  min-height: 0;
  &.Mui-expanded:first-of-type {
    min-height: 0;
    border-bottom: 1px solid ${colors.gray.light};
  }
`;

export const accordionWrapper = css`
  border: none;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const accordionContent = css`
  display: flex;
  justify-content: space-between;
  padding: 28px;
  width: 100%;
  align-items: center;
  gap: 10px;
`;
